<!--
 * @Author: liushuaibo liushuaibo@yangxuan.net
 * @Date: 2023-07-07 14:59:36
 * @LastEditors: liushuaibo liushuaibo@yangxuan.net
 * @LastEditTime: 2023-07-17 18:13:38
 * @FilePath: \partner.chaoyongtuan.com\src\views\shopManage\selectionDecoration\list\components\funDesc\index.vue
 * @Description: 这是默认设置,请设置`customMade`, 打开koroFileHeader查看配置 进行设置: https://github.com/OBKoro1/koro1FileHeader/wiki/%E9%85%8D%E7%BD%AE
-->
<template>
	<el-dialog :visible.sync="visible" title="功能说明" :before-close="beforeClose" width="400px">
		<div class="yx-color-text-p-4 font-h6-regular">
			<p>达人可通过小程序进入指定的选品中心页面；</p>
			<p>以下是选品中心配置项示意图；</p>
			<p>根据运营位的不同，可自定义跳转至商品详情页或自定义集合页；</p>
		</div>
		<div class="renovation flex flex-just-center">
			<img src="@/assets/public/renovation-fun-des.png" alt="" />
		</div>
		<div slot="footer">
			<el-button type="primary" @click="beforeClose">知道了</el-button>
		</div>
	</el-dialog>
</template>
<script>
import { getPopupAdOne } from '@/api/common';
export default {
	data() {
		return {
			visible: false,
		};
	},
	created() {
		this.getPopupAd();
	},
	methods: {
		show() {
			this.visible = true;
		},
		beforeClose() {
			this.visible = false;
		},
		async getPopupAd() {
			const { is_pop = false } = await getPopupAdOne({ type: 'product_center_tpl' });
			this.visible = is_pop;
		},
	},
};
</script>
<style lang="less" scoped>
.renovation {
	img {
		width: 182px;
	}
}
</style>
